'use client';

import { useEffect } from 'react';
import { EmptyState } from '@/components/empty-state';

const ErrorPage = ({ error }: { readonly error: Error }) => {
  useEffect(() => {
    // Log the error to an error reporting service
    console.error(error);
  }, [error]);

  return <EmptyState content='Oups... Une erreur est survenue' />;
};

export default ErrorPage;
